import axios from 'axios';
import { User, Permission } from '../types/User';

interface AuthResponse {
  authenticated: boolean;
  user: User | null;
}

// In development, use proxy. In production, use full URL
const BASE_URL = process.env.REACT_APP_API_URL || '';

export const authService = {
  loginWithMicrosoft: () => {
    // In production mode (built client), use relative path without /api prefix
    // The server has routes set up for both /auth and /api/auth
    window.location.href = `${BASE_URL}/auth/microsoft`;
  },

  checkAuthStatus: async (): Promise<AuthResponse> => {
    try {
      const response = await axios.get(`${BASE_URL}/auth/check`, {
        withCredentials: true
      });
      
      // Transform the response to ensure permissions and access are properly set
      if (response.data.authenticated && response.data.user) {
        const user = response.data.user;
        return {
          authenticated: true,
          user: {
            ...user,
            permissions: user.permissions || [],
            access: user.access || []
          }
        };
      }
      
      return {
        authenticated: false,
        user: null
      };
    } catch (error) {
      console.error('Auth check failed:', error);
      return {
        authenticated: false,
        user: null
      };
    }
  },

  // DEV ONLY: log in as a portal user by email (server rejects this in production).
  devLogin: async (email: string): Promise<AuthResponse> => {
    const response = await axios.post(
      `${BASE_URL}/auth/dev-login`,
      { email },
      { withCredentials: true }
    );
    if (response.data.authenticated && response.data.user) {
      const user = response.data.user;
      return {
        authenticated: true,
        user: { ...user, permissions: user.permissions || [], access: user.access || [] }
      };
    }
    return { authenticated: false, user: null };
  },

  logout: async (): Promise<void> => {
    await axios.get(`${BASE_URL}/auth/logout`, {
      withCredentials: true
    });
  }
}; 